import { render, staticRenderFns } from "./edit-story-modal.vue?vue&type=template&id=f99ea530"
import script from "./edit-story-modal.vue?vue&type=script&lang=js"
export * from "./edit-story-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports